<template>
  <div>
    <el-autocomplete
      v-model="area"
      :fetch-suggestions="querySearchAsync"
      placeholder="请输入小区名称"
      @select="handleSelect"
      class="dialog_search"
    >
      <el-button type="primary" slot="append" icon="el-icon-search"></el-button>

    </el-autocomplete>

    <div class="searchMesg of">
      <div class="searchLocation fl">
        当前小区：<span>{{area||''}}</span>
      </div>
      <div class="searchPrice fr">
        小区均价：<span>{{currentAreaAveragePrice ? Number(currentAreaAveragePrice).toFixed(2) : ''}}</span> 元/㎡
      </div>
    </div>
    <date-table :table-data="dialogTableData" :columns="dialogTableColumns" :is-pagination-show="false" :actions="actions"></date-table>
    <ve-line :data="priceChartData"></ve-line>
  </div>
</template>

<script>
  import DateTable from "../../components/DataTable";

  export default {
    name: "HouseHistoryPriceComponent",
    data() {
      return {
        priceChartData: {
          columns: [],
          rows: []
          // columns: ['日期', '房天下', '安居客', '链家', '58同城'],
          // rows: [
          //   { '日期': '1月', '房天下': 1393, '安居客': 1093, '链家': 3021, '58同城':1048 },
          //   { '日期': '2月', '房天下': 3530, '安居客': 3230, '链家': 2061, '58同城':1248 },
          //   { '日期': '3月', '房天下': 2923, '安居客': 2623, '链家': 7061, '58同城':1448 },
          //   { '日期': '4月', '房天下': 1723, '安居客': 1423, '链家': 4091, '58同城':1948 },
          //   { '日期': '5月', '房天下': 3792, '安居客': 3492, '链家': 3021, '58同城':1098 },
          //   { '日期': '6月', '房天下': 4593, '安居客': 4293, '链家': 7081, '58同城':1142 },
          //   { '日期': '7月', '房天下': 1393, '安居客': 1093, '链家': 3021, '58同城':1048 },
          //   { '日期': '8月', '房天下': 3530, '安居客': 3230, '链家': 2061, '58同城':1248 },
          //   { '日期': '9月', '房天下': 2923, '安居客': 2623, '链家': 7061, '58同城':1448 },
          //   { '日期': '10月', '房天下': 1723, '安居客': 1423, '链家': 4091, '58同城':1948 },
          //   { '日期': '11月', '房天下': 3792, '安居客': 3492, '链家': 3021, '58同城':1098 },
          //   { '日期': '12月', '房天下': 4593, '安居客': 4293, '链家': 7081, '58同城':1142 }
          // ]
        },

        locationList: [],
        dialogTableData: {
          data: [],
          count: 0
        },
        dialogTableColumns: [
        ],
        actions: [
          {
            label: '自动填入当前房价',
            class: 'el-button--primary',
            clickHandler: this.handleReturnPrice
          }
        ],
        area: '',
        currentAreaAveragePrice: '',
        timeout:  null,
        houseHistoryPriceList: []
      }
    },
    components: {
      DateTable
    },
    props: {

    },
    methods: {
      querySearchAsync(queryString, cb) {
        if(queryString.length <1) {
          return
        }
        let api = '/i/fang/dw/PropertyLocation.List.ds'
        let params = {
          city: '无锡',
          condition: queryString
        }

        this.$xhr.get(api, {params}, res=> {
          var results = ((res.data||{}).data||[]).map(item=>({value: item.area}))
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(results)
          }, 2000 * Math.random());
        })

      },
      handleSelect(item) {
        let api = '/i/fang/dw/PropertyValue.List.ds'
        let params = {
          city: '无锡',
          area: item.value
        }
        this.$xhr.get(api, {params}, response=> {
          const res = response.data

          if(res.status == 'success') {
            this.houseHistoryPriceList = res.data||[]

            const sourceArray = [... new Set(
              (res.data||[]).map(item=>item.source)
            )]

            const dateArray = [... new Set(
              (res.data||[]).map(item=>item.frDate)
            )]

            this.priceChartData.columns = ['日期'].concat(sourceArray)
            this.priceChartData.rows = dateArray.map(frDate=> {
              return (res.data||[]).filter(item=>item.frDate == frDate).reduce((prev, curr)=>{
                prev['日期'] = curr.frDate.substr(0,7)
                prev[curr.source] = curr.averageValue
                return prev
              }, {})
            })

            const lastMonth = dateArray[0]||''
            if(lastMonth) {

              this.dialogTableColumns = sourceArray.map(source=> ({
                label: source + '（'+ lastMonth.substr(0,7) + '）',
                field: source
              }))
              this.dialogTableData.data = [
                (res.data||[]).filter(item=>item.frDate == lastMonth).reduce( (prev, curr) => {
                  prev[curr.source] = curr.averageValue

                  return prev
                }, {})
              ]

              let priceArray = Object.values(this.dialogTableData.data[0]).reduce( (prev,curr) => {
                let price = Number(curr)||0
                if(price) prev.push(price)
                return prev
              }, [])

              this.currentAreaAveragePrice = priceArray.reduce((total, next) => total + next, 0) / priceArray.length
            }


          }
        })
      },
      handleReturnPrice: function () {
        this.$emit('getPrice', this.dialogTableData.data[0]||{})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/HouseHistoryPriceComponent.vue